import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Translate } from '_translations';
import { toggleLeaderboard } from '_redux/actioncreators/leaderboard';

class ToggleLeaderboardButton extends Component {
  render() {
    return (
      <div className={this.getClass(this.props.size)} onClick={() => this.props.toggleLeaderboard(this.props.leaderboard.isOpen)}>
        {this.props.leaderboard.isOpen &&
          (
            <Translate resourceString='Pitstop.HideTheLeaderboard' />
          )
        }
        {!this.props.leaderboard.isOpen &&
          (
            <Translate resourceString='Pitstop.ViewTheLeaderboard' />
          )
        }
      </div>
    );
  }

  getClass(size) {
    switch (size) {
      case 'large':
        return 'thunderbolt-button thunderbolt-button--large';

      default:
        return 'thunderbolt-button';
    }
  }
}

const mapStateToProps = state => ({
  leaderboard: state.app.leaderboard,
});

const mapDispatchToProps = dispatch => ({
  toggleLeaderboard: isOpen => dispatch(toggleLeaderboard(isOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToggleLeaderboardButton);
